import React, { type FC } from 'react'
import { Box, AvatarGroupInLine, Typography } from 'shared/ui'
import { type IUser } from 'entities/Users'

type IWidgetMultiUsersTriggerProps = {
  items: IUser[]
  prefix: string
}

export const WidgetMultiUsersTrigger: FC<IWidgetMultiUsersTriggerProps> = ({ items, prefix }) => {
  prefix = prefix || 'members'

  if (!items.length) return <>select</>

  const info = items.map((item) => item.avatarInfo)

  return (
    <Box display={'flex'} gap={1} alignItems={'center'} height={32}>
      <AvatarGroupInLine items={info} size={16} />
      <Typography ariaLabel={'Inbox'} variant={'body-md-regular'}>
        {items.length > 1 ? `${items.length} ${prefix}` : items[0].full_name}
      </Typography>
    </Box>
  )
}
